import { usePluginConnectionStatusTypes } from 'hooks/SparkBuilder/pluginFunction';

export const useIsConnectionValid = () => {
  const { pluginConnectionStatusTypeIDMap } = usePluginConnectionStatusTypes();

  return (pluginConnectionStatusTypeID: number | string | undefined | null) => {
    if (!pluginConnectionStatusTypeID) {
      return false;
    }
    const pluginConnectionStatusType =
      pluginConnectionStatusTypeIDMap?.[pluginConnectionStatusTypeID + ''];

    return pluginConnectionStatusType?.attributes.name === 'Authorized';
  };
};
